<template>
  <v-container
    fill-height
    fluid
    grid-list-md
  >
    <v-layout
      justify-center
    >
      <v-flex
        xs12
        md10
        xl8
      >
        <MaterialCard>
          <v-form
            :key="uniqueKey"
            v-model="ok"
            class="pt-4 px-4"
          >
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs2
                  md2
                >
                  <v-text-field
                    v-model.trim="customer.code"
                    label="顧客番号"
                    :rules="[rules.required]"
                    :error-messages="httpErrors.code"
                    @change="clearError('code')"
                  />
                </v-flex>
                <v-flex
                  xs4
                >
                  <v-text-field
                    v-model.trim="customer.name"
                    class="purple-input"
                    label="名称"
                  />
                </v-flex>
                <v-spacer />
                <v-flex
                  xs6
                  md4
                >
                  <GroupSelect
                    v-model.number="customer.area"
                    label="エリア"
                    :group="group"
                    :disable-company="true"
                    :rules="[rules.required]"
                  />
                </v-flex>
                <v-flex
                  md8
                  xs12
                >
                  <v-text-field
                    v-model.trim="customer.address"
                    label="住所"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model.trim="customer.tel"
                    label="電話番号"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model.trim="customer.remarks"
                    rows="3"
                    class="purple-input"
                    label="備考"
                  />
                </v-flex>
              </v-layout>
              <RegisterTank
                :tanks="customer.tanks"
                @add-tank="addTank"
                @remove-tank="removeTank"
              />
              <v-flex
                xs12
                text-xs-right
                class="mr-4"
              >
                <v-btn
                  color="success"
                  :disabled="!ok || loading"
                  :loading="loading"
                  @click="onRegister(customer)"
                >
                  登録
                </v-btn>
              </v-flex>
            </v-container>
          </v-form>
        </MaterialCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { GroupSelect } from '@/components/input'
import RegisterTank from './RegisterTank'

export default {
  components: {
    GroupSelect,
    RegisterTank
  },
  data: () => ({
    customer: initialCustomerData(),
    ok: false,
    loading: false,
    rules: {
      required: value => !!value || '必須項目です。'
    },
    httpErrors: {
      code: []
    },
    uniqueKey: 0
  }),
  computed: {
    ...mapState('app', ['company']),
    ...mapState('groups', ['group'])
  },
  methods: {
    ...mapMutations('app', ['setGlobalSnackBarText']),
    ...mapActions('customers', ['createCustomer']),
    addTank () {
      this.customer.tanks.push({ ...initialTankData(), no: this.customer.tanks.length + 1 })
    },
    removeTank (no) {
      const index = this.customer.tanks.findIndex(t => t.no === no)

      if (index !== -1) {
        this.customer.tanks.splice(index, 1)
        this.customer.tanks.forEach((t, i) => {
          t.no = i + 1
        })
      }
    },
    async onRegister (data) {
      this.loading = true
      const request = this.buildCustomer(data)
      try {
        await this.createCustomer(request)
        this.customer = initialCustomerData()
        this.setGlobalSnackBarText(`顧客(顧客番号: ${data.code})を追加しました。`)
      } catch (e) {
        if (e.status === 409) {
          this.httpErrors.code.push('この番号の顧客が既に存在します。')
        }
      } finally {
        this.loading = false
        ++this.uniqueKey
      }
    },
    buildCustomer (data) {
      const customer = {
        name: data.name,
        code: data.code,
        groupId: this.company.id,
        deliveryGroupId: parseInt(data.area, 10),
        address: data.address,
        tel: data.tel,
        tanks: [],
        remarks: data.remarks
      }
      for (const t of this.customer.tanks) {
        customer.tanks.push({
          tankType: parseInt(t.tankType, 10),
          volumeThreshold: t.volumeThreshold,
          deliveryFrequency: t.deliveryFrequency,
          remarks: ''
        })
      }
      return customer
    },
    clearError (field) {
      if (this.httpErrors[field].length) {
        this.httpErrors[field] = []
      }
    }
  }
}

const initialTankData = () => ({
  no: 1,
  tankType: null,
  volumeThreshold: null,
  deliveryFrequency: null
})
const initialCustomerData = () => ({
  code: null,
  name: '',
  type: '個人',
  area: null,
  address: '',
  tel: '',
  remarks: '',
  tanks: [initialTankData()]
})
</script>
